var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2000_52727)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2 8.83048C15.2 8.29866 15.1523 7.7873 15.0636 7.29639H8V10.1975H12.0364C11.8625 11.135 11.3341 11.9293 10.5398 12.4612V14.343H12.9636C14.3818 13.0373 15.2 11.1146 15.2 8.83048Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00012 16.1612C10.0251 16.1612 11.7229 15.4897 12.9638 14.3442L10.5399 12.4624C9.86831 12.9124 9.00922 13.1783 8.00012 13.1783C6.04672 13.1783 4.39331 11.859 3.80353 10.0862H1.29785V12.0294C2.53194 14.4806 5.06831 16.1612 8.00012 16.1612Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.80341 10.0865C3.65341 9.63646 3.56818 9.15577 3.56818 8.66146C3.56818 8.16714 3.65341 7.68646 3.80341 7.23646V5.29327H1.29773C0.789773 6.30577 0.5 7.45123 0.5 8.66146C0.5 9.87168 0.789773 11.0171 1.29773 12.0296L3.80341 10.0865Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00012 4.14342C9.10126 4.14342 10.0899 4.52183 10.8672 5.26501L13.0183 3.11387C11.7194 1.90364 10.0217 1.16046 8.00012 1.16046C5.06831 1.16046 2.53194 2.84114 1.29785 5.29228L3.80353 7.23546C4.39331 5.46273 6.04672 4.14342 8.00012 4.14342Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2000_52727"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.910461)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.0e7e10a8a7a0e19e7099b557f70db165.svg";
export { ForwardRef as ReactComponent };